import { getCookie, setCookie } from 'utils/cookie.helper';
import { getDomain } from 'utils/get-domain.helper';
import { TINT_SERVICE_IDS } from '../consts/tint-service.consts';
import { TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR_UPDATED_EVENT } from '../consts/tint-custom-events.consts';
import { TTintService } from '../types/service-cookie.type';
import { getServicesWithUpdatedQuantity } from './get-services-with-updated-quantity.helper';
import { getTintServicesFromCookies } from './get-tint-services-from.cookies';
import { getServicesWithNewTintService } from './get-services-with-new-tint-service.helper';
import { getTintServiceWithSelectedColorInServices } from './get-tint-service-with-selected-color-in-services.helper';

export const COOKIE_KEY_FOR_SERVICES = 'servicesInfo';

export type TUpdateTintServiceInBasketPayload = {
  parentLineId: string;
  flowQty: number;
  hex: string;
  color: string;
  serviceIdForTint: string;
};

export const updateTintServiceInServiceBasket = ({
  payload,
}: {
  payload: TUpdateTintServiceInBasketPayload;
}) => {
  const { parentLineId, color, flowQty, hex, serviceIdForTint } = payload;
  const domain = getDomain();
  const serviceCookie = getCookie(COOKIE_KEY_FOR_SERVICES) ?? '';

  try {
    const parsedServicesFromCookies =
      serviceCookie.length > 0 ? JSON.parse(decodeURIComponent(serviceCookie)) : [];
    const tintServicesForCurrentProductFromBasket = getTintServicesFromCookies({
      productCode: parentLineId,
      tintServiceIds: TINT_SERVICE_IDS,
      parsedServicesFromCookies,
    });
    const tintServiceWithSelectedColorInServices = getTintServiceWithSelectedColorInServices({
      tintServices: tintServicesForCurrentProductFromBasket as TTintService[],
      color,
    });
    const isTintServiceWithSelectedColorInServices = tintServiceWithSelectedColorInServices !== undefined;
    const newQuantity = isTintServiceWithSelectedColorInServices
      ? Number((tintServiceWithSelectedColorInServices.quantity + flowQty).toFixed(2))
      : flowQty;
    const updatedServices = isTintServiceWithSelectedColorInServices
      ? getServicesWithUpdatedQuantity({
          selectedColor: color,
          hex,
          servicesFromCookies: parsedServicesFromCookies,
          newQuantity,
        })
      : getServicesWithNewTintService({
          services: parsedServicesFromCookies,
          newTintService: { serviceIdForTint, hex, color, parentLineId },
          newQuantity,
        });

    setCookie(COOKIE_KEY_FOR_SERVICES, JSON.stringify(updatedServices), {
      expires: new Date(new Date().getFullYear() + 1, 12, 31),
      path: '/',
      domain,
    });
    document.body.dispatchEvent(
      new CustomEvent(TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR_UPDATED_EVENT, {
        cancelable: true,
        bubbles: true,
        composed: true,
        detail: newQuantity,
      })
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('updateTintServiceInServiceBasket error:', err);
  }
};
